const getMapLink = (query) => {
  if (
    typeof navigator !== "undefined" &&
    (navigator.platform.indexOf("iPhone") !== -1 ||
      navigator.platform.indexOf("iPad") !== -1 ||
      navigator.platform.indexOf("iPod") !== -1)
  ) {
    return `maps://maps.google.com/maps?q=${query}`;
  } else {
    return `https://maps.google.com/maps?q=${query}`;
  }
};

export default getMapLink;
